module.exports = __webpack_public_path__ + "img/shake_logo.a0275df6.png";